<template>
    <div>
        <el-dialog :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   :title="titleDialog"
                   :visible="showDialog"
                   width="50%"
                   @open="create">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-4 text-center font-weight-bold">
                    <p>Imprimir A4</p>
                    <button
                        class="btn btn-lg btn-info waves-effect waves-light"
                        type="button"
                        @click="clickToPrint('a4')">
                        <i class="fa fa-file-alt"></i>
                    </button>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 text-center font-weight-bold">
                    <p>Imprimir A5</p>
                    <button
                        class="btn btn-lg btn-info waves-effect waves-light"
                        type="button"
                        @click="clickToPrint('a5')">
                        <i class="fa fa-file-alt"></i>
                    </button>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 text-center font-weight-bold">
                    <p>Imprimir A5-V</p>
                    <button
                        class="btn btn-lg btn-info waves-effect waves-light"
                        type="button"
                        @click="clickToPrint('a5_v')">
                        <i class="fa fa-file-alt"></i>
                    </button>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 text-center font-weight-bold">
                    <p>Imprimir Ticket</p>
                    <button
                        class="btn btn-lg btn-info waves-effect waves-light"
                        type="button"
                        @click="clickToPrint('ticket')">
                        <i class="fa fa-receipt"></i>
                    </button>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <el-input v-model="form.customer_email">
                        <el-button
                            slot="append"
                            :loading="loading"
                            icon="el-icon-message"
                            @click="clickSendEmail">Enviar
                        </el-button>
                    </el-input>
                </div>
                <div class="col-md-12">
                    <el-input v-model="form.customer_telephone">
                        <template slot="prepend">+51</template>
                        <el-button slot="append"
                                   @click="clickSendWhatsapp">Enviar
                            <el-tooltip class="item"
                                        content="Se recomienta tener abierta la sesión de Whatsapp web"
                                        effect="dark"
                                        placement="top-start">
                                <i class="fab fa-whatsapp"></i>
                            </el-tooltip>
                        </el-button>
                    </el-input>
                    <small v-if="errors.customer_telephone"
                           class="form-control-feedback"
                           v-text="errors.customer_telephone[0]"></small>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="clickFinalize">Ir al listado</el-button>
                    <el-button type="primary" @click="clickNew">Nueva cotización</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import XInput from "../../../../components/Form/XInput.vue";

export default {
    components: {XInput},
    props: [
        'showDialog',
        'recordId',
        'showClose',
        'showGenerate',
        'type',
        'typeUser',
        'parentTable'
    ],
    data() {
        return {
            loading: false,
            titleDialog: '',
            resource: "quotations",
            errors: {},
            form: {},
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            this.errors = {};
            this.form = {};
        },
        create() {
            this.initForm()
            this.getRecord()
        },
        clickSendWhatsapp() {
            if (!this.form.customer_telephone) {
                return this.$message.error('El número es obligatorio')
            }
            window.open(`https://wa.me/51${this.form.customer_telephone}?text=${this.form.message_text}`, '_blank');
        },
        async getRecord() {
            this.loading = true
            await this.$http.get(`/${this.resource}/record2/${this.recordId}`)
                .then((response) => {
                    this.form = response.data.data;
                    let type = this.type === "edit" ? "editada" : "registrada";
                    this.titleDialog = `Cotización ${type}: ` + this.form.identifier;
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickFinalize() {
            location.href = `/${this.resource}`;
        },
        clickNew() {
            if(this.parentTable) {
                location.href = `/${this.resource}/create`;
            } else{
                this.clickClose();
            }
        },
        clickClose() {
            this.$emit("update:showDialog", false)
        },
        clickToPrint(format) {
            if (this.form.external_id == null) return null;
            window.open(`/print/${this.resource}/${this.form.external_id}/${format}`, '_blank');
        },
        async clickSendEmail() {
            this.loading = true
            await this.$http.post(`/${this.resource}/email`, {
                customer_email: this.customer_email,
                id: this.form.id,
                customer_id: this.form.quotation.customer_id,
            })
                .then((response) => {
                    if (response.data.success) {
                        this.$message.success("El correo fue enviado satisfactoriamente")
                    } else {
                        this.$message.error("Error al enviar el correo")
                    }
                })
                .catch((error) => {
                    this.$message.error("Error al enviar el correo")
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
};
</script>
